// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__r63M6","modal":"Modal_modal__DJDMv","modalImg":"Modal_modalImg__lfrvT"};